export default {
  CLASSIC: 'classic', // SCORM
  DRAFT: 'draft',
  PUBLISHED: 'published',
  NEW_VERSION_PENDING: 'new_version_pending',
};
